export const REDO_CART_TOKEN_STORAGE_KEY = "redo_cart_token";
export const REDO_CART_STORAGE_KEY = "redo_cart";
export const REDO_COVERAGE_BUILDER_STORAGE_KEY = "redo_coverage_builder";
